var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { "data-ui-section": "comments" } }, [
    _c(
      "div",
      {
        staticClass: "container container--comments px-0",
        attrs: { id: "container--comments" }
      },
      [
        _c(
          "div",
          { staticClass: "comments mt-0", attrs: { id: "comments" } },
          [
            _c("post-reply-box", {
              ref: "commentReplyBox",
              staticClass: "d-none d-md-block",
              attrs: {
                user: _vm.user,
                persistent: "",
                "video-id": _vm.video.id,
                "before-open": _vm.checkForLogin
              },
              on: { success: _vm.updateParent }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "comment__new__contactus hidden" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("video.action.conversations.having_trouble")) +
                  "\n        "
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "#",
                    "data-toggle": "modal",
                    "data-target": "#modal-support"
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("video.action.conversations.contact_us"))
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "comment-content" },
              _vm._l(_vm.data.comments, function(comment) {
                return _c(
                  "div",
                  { key: comment.id, staticClass: "comment rounded" },
                  [
                    _c("comment-post", {
                      attrs: {
                        comment: comment,
                        user: _vm.user,
                        "video-id": _vm.video.id
                      },
                      on: { success: _vm.updateParent }
                    })
                  ],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.hasMorePages
              ? _c(
                  "button",
                  {
                    ref: "seeMoreSpinner",
                    staticClass: "vs-btn btn btn--outline--dark rounded w-100",
                    attrs: { type: "button" },
                    on: { click: _vm.loadComments }
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("video.action.conversations.see_more"))
                      )
                    ]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "status",
                      class: _vm.isLoading ? "loading" : ""
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("post-reply-box", {
              ref: "commentReplyBox",
              staticClass: "d-block d-md-none",
              attrs: {
                user: _vm.user,
                persistent: "",
                "video-id": _vm.video.id,
                "before-open": _vm.checkForLogin
              },
              on: { success: _vm.updateParent }
            })
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }